import PropTypes from 'prop-types';

import { ACCESS_CONTROL_PROVIDERS } from 'shared/constants';
import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  cardNumberRange,
  facilityCodeRange,
  formatSelect,
  lastCardNumberValidation,
  lengthValidation60,
  onlyNumeric,
  required,
} from '../Forms/utils';

import { REACT_SELECT_INPUT, STYLED_TEXT } from '../Forms/fieldTypes';

const AccessCardBatchFormComponent = (props) => {
  const {
    form,
    onSubmit,
    onLoad,
    initialValues,
    isCreate,
    property,
    isLyazonType,
    selectedType,
  } = props;

  const { t } = useTransl();

  const formData = [
    {
      keyName: 'type',
      label: t('title.type'),
      fieldType: REACT_SELECT_INPUT,
      options: [
        ACCESS_CONTROL_PROVIDERS.two_n,
        ACCESS_CONTROL_PROVIDERS.lyazon,
      ],
      validate: [required],
    },
    {
      keyName: 'property',
      label: t('title.property'),
      fieldType: REACT_SELECT_INPUT,
      options: formatSelect(Object.values(property)),
      validate: [required],
      isHidden: !selectedType,
    },
    {
      keyName: 'name',
      label: t('title.batchName'),
      fieldType: STYLED_TEXT,
      validate: [required],
      isHidden: !selectedType,
    },
    {
      keyName: 'facilityCode',
      label: t('title.facilityCode'),
      fieldType: STYLED_TEXT,
      validate: isLyazonType ? [] : [required, onlyNumeric, facilityCodeRange],
      isHidden: !selectedType,
    },
    {
      keyName: 'cardNumbersList',
      label: t('title.cardNumbersList'),
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: isLyazonType && isCreate ? [required] : [],
      isHidden: !selectedType || !isLyazonType || !isCreate,
    },
    {
      keyName: 'firstCardNumber',
      label: t('title.firstCardNumber'),
      fieldType: STYLED_TEXT,
      validate: isLyazonType ? [] : [required, onlyNumeric, cardNumberRange],
      isHidden: !selectedType || isLyazonType,
    },
    {
      keyName: 'lastCardNumber',
      label: t('title.lastCardNumber'),
      fieldType: STYLED_TEXT,
      validate: isLyazonType
        ? []
        : [required, onlyNumeric, cardNumberRange, lastCardNumberValidation],
      isHidden: !selectedType || isLyazonType,
    },
    {
      keyName: 'cardNumberOffset',
      label: t('title.cardNumberOffset'),
      fieldType: STYLED_TEXT,
      validate: isLyazonType ? [] : [required, lengthValidation60],
      isHidden: !selectedType || isLyazonType,
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      title={isCreate ? t('accessCard.addBatch') : t('accessCard.updateBatch')}
      submitText={isCreate ? t('actions.create') : t('actions.update')}
      onLoad={onLoad}
      enableReinitialize
    />
  );
};

AccessCardBatchFormComponent.defaultProps = {
  property: {},
  selectedType: null,
};
AccessCardBatchFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  isCreate: PropTypes.bool.isRequired,
  property: PropTypes.instanceOf(Object),
  isLyazonType: PropTypes.bool.isRequired,
  selectedType: PropTypes.string,
};

export default AccessCardBatchFormComponent;
